import 'css-chunksrc/client/scenes/secondaryCriteriaTemplate/criteria/form/typeInput/styles.scss';export default {
  "nameInput": "_nameInput_p54um_1",
  "group": "_group_p54um_5",
  "label": "_label_p54um_9",
  "input": "_input_p54um_15",
  "listRoot": "_listRoot_p54um_29",
  "list": "_list_p54um_29",
  "item": "_item_p54um_41",
  "selected": "_selected_p54um_57",
  "row": "_row_p54um_62",
  "icon": "_icon_p54um_70",
  "open": "_open_p54um_78",
  "toggleArrow": "_toggleArrow_p54um_83"
};